import { FolderKanban } from 'lucide-react';
import { useAuth } from '@/auth/useAuth';
import { Avatar, EmptyState } from '@/components/ui';

/*
  Portfolio — страница автора-разработчика модулей. /portfolio/me показывает
  собственный портфолио, /portfolio/<userId> — чужой.

  Sprint 1: только своё, без чужих. Реальные модули появятся в Sprint 2+
  (Module Runtime).
*/

export function Portfolio() {
  const { state } = useAuth();
  const user = state.status === 'authenticated' ? state.user : null;

  return (
    <div className="mx-auto max-w-5xl px-8 py-10">
      <header className="mb-8 flex items-center gap-4">
        <Avatar src={user?.avatar_url} name={user?.display_name} size="xl" />
        <div>
          <div className="flex items-center gap-2">
            <h1 className="text-2xl font-semibold tracking-tight">{user?.display_name ?? 'Моё портфолио'}</h1>
            {/* Sprint 1.14: strong coral pill вместо неконтрастного coral-100/coral-800.
                Inline gradient + white text, чтобы badge был читаемый и
                сразу выделялся как marker «свой профиль». */}
            <span
              className="inline-flex items-center rounded-full bg-gradient-to-br from-brand-highlight to-brand-action px-2 py-0.5 text-2xs font-semibold tracking-wide text-white uppercase shadow-brand-tag"
              aria-label="Это твой профиль"
            >
              это ты
            </span>
          </div>
          <p className="mt-1 text-sm text-fg-muted">Модули которые ты создал и поддерживаешь</p>
        </div>
      </header>

      <EmptyState
        icon={<FolderKanban />}
        title="Ещё ничего не опубликовано"
        description="Когда подключим Module Runtime, отсюда можно будет создавать модули — AI-built, declarative или native. Каждый с твоим именем как owner'а."
        action={{ label: 'Что уже есть', to: '/marketplace' }}
      />
    </div>
  );
}
